import { render, staticRenderFns } from "./aufgabe-attachment-reisetermin-table.vue?vue&type=template&id=61182970&scoped=true"
import script from "./aufgabe-attachment-reisetermin-table.vue?vue&type=script&lang=js"
export * from "./aufgabe-attachment-reisetermin-table.vue?vue&type=script&lang=js"
import style0 from "./aufgabe-attachment-reisetermin-table.vue?vue&type=style&index=0&id=61182970&prod&lang=css"
import style1 from "./aufgabe-attachment-reisetermin-table.vue?vue&type=style&index=1&id=61182970&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61182970",
  null
  
)

export default component.exports